"use strict";

(() => {
	class Crypto_FOMO_Calculator {
		/** @var {HTMLElement} */
		#$widget;

		/** @var {object} */
		#exchangeRates;

		/** @var {HTMLInputElement} */
		#$dateInput;

		/** @var {AirDatepicker} */
		#datePicker;

		/** @var {HTMLInputElement} */
		#$amountInput;

		/** @var {HTMLInputElement} */
		#$inputCurrencyInput;

		/** @var {HTMLInputElement} */
		#$outputCurrencyInput;

		/** @var {HTMLElement} */
		#$resultWrapper

		/** @var {HTMLElement} */
		#$resultAmount;


		constructor($widget, exchangeRates) {
			this.#$widget       = $widget;
			this.#exchangeRates = exchangeRates;
		}

		initialize() {
			// Get elements.
			this.#$dateInput           = this.#$widget.querySelector(".dan-input-date");
			this.#$amountInput         = this.#$widget.querySelector(".dan-input-amount");
			this.#$inputCurrencyInput  = this.#$widget.querySelector(".dan-input-input-currency");
			this.#$outputCurrencyInput = this.#$widget.querySelector(".dan-input-output-currency");
			this.#$resultWrapper       = this.#$widget.querySelector(".dan-sentence-result-wrap");
			this.#$resultAmount        = this.#$widget.querySelector(".dan-sentence-result.-amount");

			// Initialize Air Datepicker.
			this.#datePicker = new AirDatepicker(this.#$dateInput, {
				locale: AirDatepickerLocaleCs,
				selectedDates: (this.#$dateInput.value)
					? [this.#$dateInput.value]
					: [],
				dateFormat: "dd. MM. yyyy",
				position: "bottom center",
				view: "years",
				keyboardNav: false,
				toggleSelected: false,
				onSelect: () => {
					// noinspection JSUnresolvedReference
					this.#datePicker.hide()
				}
			});

			// Attach handlers to events.
			this.#$widget.addEventListener("submit", (this.#onFormSubmit).bind(this));
			this.#$dateInput.addEventListener("input", (this.#onDateInput).bind(this));
		}

		/**
		 * @param {SubmitEvent} event
		 */
		#onFormSubmit(event) {
			event.preventDefault();

			// Load inputs.
			const inputs = this.getInputs();

			if (inputs.date === null || inputs.amount === null) {
				alert("Prosím, vyplňte všechna pole.");
				return;
			}

			// Calc and format results.
			let resultAmount;
			resultAmount = this.#calcAmount(inputs);
			resultAmount = (resultAmount)
				? Dan_Utilities.formatPriceByCurrency(resultAmount, inputs.outputCurrency)
				: null;

			if (resultAmount === null) {
				alert("Hodnotu Vaší investice bohužel nebylo možné vypočítat. Zkuste prosím nastavit jiné datum nákupu.");
				return;
			}

			if (this.#$resultWrapper.classList.contains("-active")) {
				this.#slideResultUp(() => {
					this.#$resultAmount.textContent = resultAmount;
					this.#slideResultDown();
				});
			} else {
				this.#$resultAmount.textContent = resultAmount;
				this.#slideResultDown();
			}
		}

		#calcAmount(inputs) {
			const today = new Date();

			// Get input amount in USD.
			let inputAmountUSD = inputs.amount;

			if (inputs.inputCurrency !== "USD") {
				const inputExchangeRate = this.#getExchangeRate(
					inputs.inputCurrency,
					"USD",
					inputs.date
				);

				if (inputExchangeRate === null) {
					return null;
				}

				inputAmountUSD = (inputAmountUSD * inputExchangeRate);
			}

			// Calc output amount.
			const cryptoPastExchangeRate  = this.#getExchangeRate("BTC", "USD", inputs.date);
			const cryptoTodayExchangeRate = this.#getExchangeRate("BTC", "USD", today);

			if (cryptoPastExchangeRate === null || cryptoTodayExchangeRate === null) {
				return null;
			}

			const amountCrypto = (inputAmountUSD / cryptoPastExchangeRate);

			// Get output amount.
			let outputAmount = (amountCrypto * cryptoTodayExchangeRate);

			if (inputs.outputCurrency !== "USD") {
				const outputExchangeRate = this.#getExchangeRate(
					inputs.outputCurrency,
					"USD",
					today
				);

				if (outputExchangeRate === null) {
					return null;
				}

				outputAmount = (outputAmount / outputExchangeRate);
			}

			return outputAmount;
		}

		#getExchangeRate(assetBase, assetQuote, date) {
			const assetPair  = assetBase + "/" + assetQuote;
			const dateFormat = window.dayjs(date).format("YYYY-MM-DD");

			let rate;

			if (typeof this.#exchangeRates["exact"][assetPair][dateFormat] === "number") {
				rate = this.#exchangeRates["exact"][assetPair][dateFormat];
			} else if (typeof this.#exchangeRates["medians"][assetPair] === "number") {
				rate = this.#exchangeRates["medians"][assetPair];
			} else {
				rate = this.#getClosestExchangeRate(assetBase, assetQuote, date);
			}

			return rate;
		}

		#getClosestExchangeRate(assetBase, assetQuote, refDateString) {
			const assetPair = assetBase + "/" + assetQuote;
			const refDate   = new Date(refDateString);

			let closestDate = null;
			let closestDiff = null;

			for (const iDateString in this.#exchangeRates["exact"][assetPair]) {
				const iDate     = new Date(iDateString);
				const datesDiff = Math.abs(refDate - iDate);

				if (closestDiff === null || datesDiff < closestDiff) {
					closestDate = iDateString;
					closestDiff = datesDiff;
				}
			}

			return this.#exchangeRates["exact"][assetPair][closestDate];
		}

		#slideResultUp(callback = null) {
			this.#$resultWrapper.style.height = this.#$resultWrapper.scrollHeight + "px";

			setTimeout(() => {
				this.#$resultWrapper.style.height = "0";
			}, 25);

			setTimeout(() => {
				this.#$resultWrapper.classList.remove("-active");

				if (typeof callback === "function") {
					callback();
				}
			}, 175);
		}

		#slideResultDown(callback = null) {
			this.#$resultWrapper.style.height = this.#$resultWrapper.scrollHeight + "px";

			setTimeout(() => {
				this.#$resultWrapper.style.height = "auto";
				this.#$resultWrapper.classList.add("-active");

				if (typeof callback === "function") {
					callback();
				}
			}, 150);
		}

		#onDateInput() {
			const inputs = this.getInputs();

			if (inputs.date) {
				// noinspection JSUnresolvedReference
				this.#datePicker.selectDate(inputs.date, {
					silent: true
				});

				// noinspection JSUnresolvedReference
				this.#datePicker.setViewDate(inputs.date);
			}
		}

		getInputs() {
			// Date.
			const dateValue  = this.#$dateInput.value.trim();
			const dateParsed = /^(\d{2})\. (\d{2})\. (\d{4})$/.exec(dateValue);
			const date       = (dateParsed)
				? new Date(dateParsed[3] + "-" + dateParsed[2] + "-" + dateParsed[1])
				: null;

			// Initial deposit.
			let amount;
			amount = this.#$amountInput.value || this.#$amountInput.placeholder;
			amount = parseInt(amount);

			if (isNaN(amount) || amount < 0) {
				amount = null;
			}

			// Currencies.
			const inputCurrency  = this.#$inputCurrencyInput.value || "CZK";
			const outputCurrency = this.#$outputCurrencyInput.value || "CZK";

			// Return.
			return {
				date: date,
				amount: amount,
				inputCurrency: inputCurrency,
				outputCurrency: outputCurrency
			};
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll("form.dan-crypto-fomo-sentence");

	for (const $widget of $widgets) {
		let exchangeRates;
		exchangeRates = $widget.getAttribute("data-exchange-rates") || null;
		exchangeRates = (exchangeRates)
			? JSON.parse(exchangeRates)
			: null;

		$widget.calculator = new Crypto_FOMO_Calculator($widget, exchangeRates);
		$widget.calculator.initialize();
	}
})();
